import { aloApiFetch } from 'src/scripts/utils/alo-api-fetch';

const LOYALTY_BLOCKED_STATUS_API_ENDPOINT = '/v2/loyalty/blocked';
const LOCAL_STORAGE_KEY = 'loyalty_blocked_status';

let activeApiPromise: Promise<boolean> | undefined;

const fetchLoyaltyBlockedStatus = (email: string): Promise<boolean> => {
  if (activeApiPromise) return activeApiPromise;
  const encodedEmail = encodeURIComponent(email);
  activeApiPromise = aloApiFetch(`${LOYALTY_BLOCKED_STATUS_API_ENDPOINT}?email=${encodedEmail}`, {
    method: 'GET',
  })
    .then((response) => {
      if (response) {
        return response.json().then(({ blocked }) => blocked);
      }
    })
    .catch((err) => {
      console.error(err);
      // default to showing Loyalty
      return false;
    })
    .finally(() => {
      activeApiPromise = undefined;
    });
  return activeApiPromise;
};

export const getLoyaltyBlockedStatus = async (): Promise<boolean> => {
  const customerEmail = window.getSiteSettings().customerEmail;
  const cachedValue = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!customerEmail) {
    if (cachedValue) localStorage.removeItem(LOCAL_STORAGE_KEY);
    return false;
  }
  if (cachedValue) {
    const localstorageValueObj = JSON.parse(cachedValue);
    const tenMinutes = 1000 * 60 * 10;
    const isCacheExpired = Number(localstorageValueObj.timestamp) + tenMinutes < Date.now();
    if (!isCacheExpired) {
      return localstorageValueObj.blockedStatus;
    }
  }
  let blockedStatus = await fetchLoyaltyBlockedStatus(customerEmail);
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ blockedStatus, timestamp: Date.now() }));
  return blockedStatus;
};
